/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data payload for \'email.sent\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface EmailSentData { 
    appointmentId: number;
}
export const EmailSentData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];


